import Button from "@components/Atoms/Button";
// import Title from "@components/Atoms/Title";
import tw, { styled, css, theme } from "twin.macro";

const customStylesButton = css`
  ${tw`p-0 w-8 h-8 flex items-center justify-center py-4 px-4 shadow-elevation-1 absolute z-40 transition-all ease-in-out duration-300 top-[calc(50%-theme('space.4'))]
    large:(w-10 h-10 py-6 px-6 duration-500 top-[calc(50%-theme('space.6'))])
  `}

  & > span > svg {
    ${tw`w-4 h-4 large:(w-6 h-6)`}
  }

  &.swiper-navigation-hidden,
  &.swiper-navigation-disabled {
    ${tw`opacity-0`}
  }
`;

export const StyledButtonPrev = styled(Button)`
  ${customStylesButton}
  ${tw`-left-3 medium:(-left-4) large:(-left-6)`}
`;

export const StyledButtonNext = styled(Button)`
  ${customStylesButton}
  ${tw`-right-3 medium:(-right-4) large:(-right-6)`}
`;

export const StylesWrapperPagination = styled.div`
  ${tw`!(transform translate-x-[-100%] left-[100%])`}

  --swiper-pagination-color: ${theme`colors.secondary.50`};
  --swiper-pagination-bullet-size: 12px;
  --swiper-pagination-bullet-width: 12px;
  --swiper-pagination-bullet-height: 12px;
  --swiper-pagination-bullet-inactive-color: ${theme`colors.secondary.70`};
  --swiper-pagination-bullet-inactive-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bottom: -1.5rem;
`;

export const StyledWrapperSwiperProductGallery = styled.div<{ $isSmall?: boolean }>`
    ${tw`w-full`}

  & article.swiper-slide {
    ${tw`w-min h-auto! all-child:h-full`};


    ${({ $isSmall }) =>
      $isSmall &&
      css`
        & > div,
        & > a {
          ${tw`max-w-full h-full!`}

          & figure {
            ${tw`w-full`}

            & img {
              ${tw`object-fill`}
            }
          }
        }
      `})}
  }
`;

export const StyledWrapperRoot = styled.section`
  ${tw`relative mb-10 gap-s flex flex-col z-0
    medium:(gap-sm)
    large:(gap-m)
  `}
`;

export const StyledWrapperHead = styled.div<{ $addPadding?: boolean }>`
  ${tw`flex items-center justify-between`}

  ${({ $addPadding }) =>
    $addPadding &&
    css`
      ${tw`px-2 medium:px-2 large:px-4`}
    `}
`;
